/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

function CITFieldServicesReport({ data }: { data: any[] }) {
  const [dataState, setDataState] = useState<any>(initialDataState);

  return (
    <Grid
      className="text-sm"
      data={process(
        data.map((req) => ({
          ...req,
        })),
        dataState
      )}
      {...dataState}
      onDataStateChange={(e: any) => {
        setDataState(e.dataState);
      }}
      size="small"
    >
      <Column
        field="serialNo"
        title="Sr. #"
        width="50px"
        className="text-sm text-center"
      />
      <Column
        field="customer"
        title="Customer"
        width="120px"
        className="text-sm"
      />
      <Column
        field="source"
        title="Pickup Site"
        width="120px"
        className="text-sm"
      />
      <Column
        field="destination"
        title="Delivery Site"
        width="150px"
        className="text-sm"
      />
      <Column
        field="serviceType"
        title="Service Type"
        width="150px"
        className="text-sm"
      />
      <Column
        field="routeNo"
        title="Route No"
        width="100px"
        className="text-sm"
      />
      <Column
        field="ccDepartTime"
        title="CC Depart"
        width="120px"
        className="text-sm text-center"
      />
      <Column
        field="serviceStartTime"
        title="Service Start"
        width="130px"
        className="text-sm text-center"
      />
      <Column
        field="serviceEndTime"
        title="Service End"
        width="120px"
        className="text-sm text-center"
      />
      <Column
        field="ccArrivalTime"
        title="CC Arrival"
        width="120px"
        className="text-sm text-center"
      />
      <Column
        field="handoverTime"
        title="Handover"
        width="120px"
        className="text-sm text-center"
      />
      <Column field="status" title="Status" width="100px" className="text-sm" />
      <Column
        field="reason"
        title="Pending Reason"
        width="180px"
        className="text-sm"
      />
      <Column
        field="remarks"
        width="180px"
        title="remarks"
        className="text-sm"
      />
    </Grid>
  );
}

export default React.memo(CITFieldServicesReport);
